var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonObject, JsonProperty } from "json2typescript";
let BrandsImageProfileModel = class BrandsImageProfileModel {
};
__decorate([
    JsonProperty("href", String, true)
], BrandsImageProfileModel.prototype, "href", void 0);
BrandsImageProfileModel = __decorate([
    JsonObject("BrandsImageProfileModel")
], BrandsImageProfileModel);
export { BrandsImageProfileModel };
let BrandsTreeModel = class BrandsTreeModel {
    constructor() {
        this.access_type = "";
        this.id = -1;
        this.name = "";
        this.is_closed = false;
        this.type = "";
        this.profile_image = new BrandsImageProfileModel();
        this.brands = [];
    }
};
__decorate([
    JsonProperty("access_type", String)
], BrandsTreeModel.prototype, "access_type", void 0);
__decorate([
    JsonProperty("id", Number)
], BrandsTreeModel.prototype, "id", void 0);
__decorate([
    JsonProperty("name", String)
], BrandsTreeModel.prototype, "name", void 0);
__decorate([
    JsonProperty("is_closed", Boolean, true)
], BrandsTreeModel.prototype, "is_closed", void 0);
__decorate([
    JsonProperty("type", String)
], BrandsTreeModel.prototype, "type", void 0);
__decorate([
    JsonProperty("profile_image", BrandsImageProfileModel)
], BrandsTreeModel.prototype, "profile_image", void 0);
__decorate([
    JsonProperty("brands", [BrandsTreeModel], true)
], BrandsTreeModel.prototype, "brands", void 0);
BrandsTreeModel = __decorate([
    JsonObject("BrandsTreeModel")
], BrandsTreeModel);
export { BrandsTreeModel };
//# sourceMappingURL=brands-tree.model.js.map